import { Team, Lead } from '../types'

export const TEAMS: Team[] = [
  {
    id: 't1',
    name: 'Purchase Loans',
    campaignName: 'Purchase – First Time Buyers Q1',
    color: '#0D9488', // Teal
    users: [
      { id: 'u1', name: 'Marcus Johnson', avatarInitials: 'MJ', teamId: 't1' },
      { id: 'u2', name: 'Sarah Chen', avatarInitials: 'SC', teamId: 't1' },
      { id: 'u3', name: 'David Rodriguez', avatarInitials: 'DR', teamId: 't1' },
    ],
  },
  {
    id: 't2',
    name: 'Refinance',
    campaignName: 'Refi Rate Drop Campaign',
    color: '#3B82F6', // Blue
    users: [
      { id: 'u4', name: 'Emily Wilson', avatarInitials: 'EW', teamId: 't2' },
      { id: 'u5', name: 'James Kim', avatarInitials: 'JK', teamId: 't2' },
      { id: 'u6', name: 'Robert Taylor', avatarInitials: 'RT', teamId: 't2' },
    ],
  },
  {
    id: 't3',
    name: 'FHA / VA Loans',
    campaignName: 'FHA-VA Spring Outreach',
    color: '#F59E0B', // Amber
    users: [
      { id: 'u7', name: 'Lisa Anderson', avatarInitials: 'LA', teamId: 't3' },
      { id: 'u8', name: 'Michael Brown', avatarInitials: 'MB', teamId: 't3' },
      {
        id: 'u9',
        name: 'Jennifer Martinez',
        avatarInitials: 'JM',
        teamId: 't3',
      },
      { id: 'u10', name: 'Kevin White', avatarInitials: 'KW', teamId: 't3' },
    ],
  },
  {
    id: 't4',
    name: 'Jumbo Loans',
    campaignName: 'Jumbo High-Value Nurture',
    color: '#8B5CF6', // Violet
    users: [
      { id: 'u11', name: 'Thomas Lee', avatarInitials: 'TL', teamId: 't4' },
      {
        id: 'u12',
        name: 'Patricia Garcia',
        avatarInitials: 'PG',
        teamId: 't4',
      },
      {
        id: 'u13',
        name: 'Christopher Clark',
        avatarInitials: 'CC',
        teamId: 't4',
      },
    ],
  },
  {
    id: 't5',
    name: 'Home Equity / HELOC',
    campaignName: 'HELOC Equity Tap Campaign',
    color: '#EC4899', // Pink
    users: [
      { id: 'u14', name: 'Daniel Lewis', avatarInitials: 'DL', teamId: 't5' },
      {
        id: 'u15',
        name: 'Amanda Robinson',
        avatarInitials: 'AR',
        teamId: 't5',
      },
    ],
  },
]

const SOURCES = [
  'Zillow',
  'LendingTree',
  'Realtor Referral',
  'Facebook Ads',
  'Google Ads',
]

const FIRST_NAMES = [
  'John',
  'Emma',
  'Oliver',
  'Sophia',
  'William',
  'Ava',
  'James',
  'Isabella',
  'Benjamin',
  'Mia',
  'Lucas',
  'Charlotte',
  'Henry',
  'Amelia',
  'Alexander',
  'Harper',
  'Sebastian',
  'Evelyn',
  'Jack',
  'Abigail',
  'Daniel',
  'Grace',
  'Matthew',
  'Chloe',
  'Andrew',
  'Lily',
  'Nathan',
  'Ella',
  'Ryan',
  'Zoe',
  'Tyler',
  'Hannah',
  'Brandon',
  'Victoria',
  'Aaron',
  'Madison',
  'Jose',
  'Samantha',
  'Kevin',
  'Natalie',
]

const LAST_NAMES = [
  'Smith',
  'Davis',
  'Wilson',
  'Miller',
  'Jones',
  'Brown',
  'Garcia',
  'Rodriguez',
  'Martinez',
  'Hernandez',
  'Lopez',
  'Gonzalez',
  'Anderson',
  'Thomas',
  'Taylor',
  'Moore',
  'Jackson',
  'Martin',
  'Lee',
  'Thompson',
  'White',
  'Harris',
  'Clark',
  'Lewis',
  'Robinson',
  'Walker',
  'Young',
  'Allen',
  'King',
  'Wright',
  'Scott',
  'Torres',
  'Nguyen',
  'Hill',
  'Flores',
  'Green',
  'Adams',
  'Nelson',
  'Baker',
  'Hall',
]

// Generate 80 realistic mortgage leads
export const MOCK_LEADS: Lead[] = Array.from({ length: 80 }).map((_, i) => {
  const date = new Date()
  date.setDate(date.getDate() - Math.floor(Math.random() * 14))
  const firstName = FIRST_NAMES[i % FIRST_NAMES.length]
  const lastName = LAST_NAMES[i % LAST_NAMES.length]
  const emailDomains = [
    'gmail.com',
    'yahoo.com',
    'outlook.com',
    'icloud.com',
    'hotmail.com',
  ]

  return {
    id: `l${i + 1}`,
    name: `${firstName} ${lastName}`,
    email: `${firstName.toLowerCase()}.${lastName.toLowerCase()}${i + 1}@${emailDomains[i % emailDomains.length]}`,
    phone: `(${String(Math.floor(Math.random() * 900) + 200)}) ${String(Math.floor(Math.random() * 900) + 100)}-${String(Math.floor(Math.random() * 9000) + 1000)}`,
    source: SOURCES[i % SOURCES.length],
    dateAdded: date.toISOString().split('T')[0],
    status: 'unassigned',
  }
})
